import React, { useEffect, useState } from "react"
// import { MDBDataTable } from "mdbreact"
import {
  Row, Col, Card, CardBody, CardTitle, CardSubtitle, Button, Modal,
  ModalBody
} from "reactstrap"
// import "./datatables.scss";
import '../Icons/IconFontawesome';

import DataTable from 'react-data-table-component';
import Utils from '../Utility';
import { post, get, put } from "../../helpers/api_helper";
// import DeleteModal from '../Moderator/DeleteModal';
import DeleteModal from '../Users/DeleteModal';
import { AvField, AvForm } from "availity-reactstrap-validation";

const DatatableTables = (props) => {
  const { user, role, currentUser } = props;
  const [columns, setColumns] = useState([]);
  const [data, setData] = useState([]);
  const [deleteModal, setDeleteModal] = useState(false);
  const [distriModal, setDistriModal] = useState(false);
  const [autoDealer, setAutoDealers] = useState([]);

  useEffect(() => {
    if (user?.token)
      getUsers();
  }, [user]);

  const getUsers = () => {
    console.log('calling get user list get method');
    get("/user/list", { token: user?.token })
      .then(json => {
        console.log('response from get user list', json);
        if (json.statusCode == 200) {
          setColumns([
            {
              name: 'Name',
              selector: row => row.name,
            },
            {
              name: 'Email',
              selector: row => row.email,
            },
            {
              name: 'Mobile',
              selector: row => row.mobile,
            },
            {
              name: 'Address',
              selector: row => row.address,
            },
            {
              name: 'Status',
              selector: row => row.isEmailVerified ? 'Verified' : 'Pending',
              cell: (row) => row.isEmailVerified ? <span style={{ backgroundColor: 'green', padding: 5, color: 'white', borderRadius: 3 }}>Verified</span> : <span style={{ backgroundColor: 'orange', padding: 5, color: 'white', borderRadius: 3 }}>Pending</span>
            },
            {
              cell: (row) => <>
                <Button onClick={() => handleUpdateUser(row)} style={{ backgroundColor: user?.company?.theme ? user?.company?.theme : Utils.themeColor, marginRight: 10, padding: 5, paddingLeft: 8, paddingRight: 8 }}><span className="mdi mdi-account-edit" style={{ fontSize: 20 }}></span></Button>
                <Button onClick={() => handleDeleteUser(row)} style={{ backgroundColor: user?.company?.theme ? user?.company?.theme : Utils.themeColor, marginRight: 10, padding: 5, paddingLeft: 8, paddingRight: 8 }}><span className="mdi mdi-cancel" style={{ fontSize: 20 }}></span></Button>
              </>,
              name: 'Action',
              ignoreRowClick: true,
              allowOverflow: true,
              button: true,
              minWidth: '10%'
            },
          ]);
          setData(json?.data);
        }
      })
      .catch(error => {
        console.log('error while getting user list', error);
      })
  }

  const handleUpdateUser = (user) => {
    console.log('updating user', user);
    props?.setCurrentUser(user);
    props.add(true);
  }

  const handleDeleteUser = (user) => {
    console.log('updating user', user);
    props?.setCurrentUser(user);
    setDeleteModal(true);
  }

  const onDelete = () => {
    console.log('deleted', currentUser);
    post("/user/delete", { user_id: currentUser?._id, token: user?.token })
      .then(json => {
        console.log('response from delete user', json);
        if (json.statusCode == 200) {
          getUsers();
          setDeleteModal(false);
          props?.setCurrentUser(null);
          props?.getProfile(user);
        }
      })
      .catch(error => {
        console.error('error while deleting user', error);
      })
  }

  return (
    <React.Fragment>
      <div className="">
        <Row>
          <DeleteModal
            show={deleteModal}
            onDeleteClick={() => onDelete()}
            onCloseClick={() => setDeleteModal(false)}
          />
          <Col className="col-12">
            <Card>
              <CardBody>
                <div className="d-flex" style={{ marginLeft: 'auto' }}>
                  <div>
                    <CardTitle className="h4">Users</CardTitle>
                      <CardSubtitle className="mb-3">
                        All Users who have regsitered, They can be manage from here!.
                      </CardSubtitle>
                  </div>
                </div>
                {/* <MDBDataTable
                  responsive
                  striped
                  bordered
                  data={data}
                  noBottomColumns={true}
                /> */}
                <DataTable
                  columns={columns}
                  data={data}
                  pagination
                  customStyles={{
                    headCells: {
                      style: {
                        color: 'black',
                        fontWeight: 'bold',
                        fontSize: 15
                      },
                    }
                  }}
                />
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>

    </React.Fragment>
  )
}

export default DatatableTables
